export const ADMINS_TABLE = {
    'ADMINS.COLUMN.NAME': 'Nume',
    'ADMINS.COLUMN.EMAIL': 'E-mail',
    'ADMINS.COLUMN.STATUS': 'Status',
    'ADMINS.COLUMN.DATE': 'Dată actualizare',
    'ADMINS.COLUMN.UPDATED_BY': 'Actualizat de',
    'ADMINS.COLUMN.ACTIONS': 'Acțiuni',
    'ADMINS.SEARCH_PLACEHOLDER': 'Caută Nume/E-mail',
    'ADMINS.ACTION.ADD': 'Admin nou',
    'ADMINS.ACTION.DEACTIVATE_ACCESS': 'Dezactivează acces',
    'ADMINS.ACTION.REACTIVATE_ACCESS': 'Reactivează acces',
    'ADMINS.FILTER.STATUS': 'Status'
};
